import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiResponse } from 'src/app/shared/interfaces/api-response.interface';
import { Mesa } from 'src/app/shared/models/mesa';
import { AuthenticationService } from './authentication.service';
import { MesaRequest } from 'src/app/shared/models/mesa-request';

@Injectable({
  providedIn: 'root'
})
export class MesaService {
  constructor(
    private _httpClient: HttpClient,
    private _authService: AuthenticationService
  ) { }

  private get base() {
    return `${this._authService.baseUrl}/Mesa`;
  }

  public criarVariasMesas(mesas: MesaRequest[]) {
    return this._httpClient.post<ApiResponse>(`${this.base}/CriarVariasMesas`, mesas);
  }

  public excluirMesa(numeroMesa: number) {
    return this._httpClient.delete<ApiResponse>(`${this.base}/${numeroMesa}`);
  }

  public obterMesasCadastradas() {
    return this._httpClient.get<ApiResponse<Mesa[]>>(`${this.base}/MesasCadastradas`);
  }
}
